import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as S from "./SeoPage.styles";
import SeoSearchHeader from "../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI";
import SeoPageHeader from "./containers/SeoPageHeader/SeoPageHeaderUI";
import SeoContainer from "./containers/SeoContainer/SeoContainer";
import SeoInterLinking from "./containers/SeoInterLinking/SeoInterLinking";
import Filter from '../../containers/Filter/Filter';
import SafetyFeeds from '../SearchPage/components/SafetyFeeds/SafetyFeeds';
import Listing from './containers/Listing/Listing';
import AirportTripSelector from '../../../stories/components/cars/SeoPage/AirportTripSelector/AirportTripSelector';
import { pageView } from "../../config/ga";
import { lobDataSelector, SeoMetaSelector, showSEOLeadgenSelector, waySelector } from './redux/selector';
import { getLoadedComponent, sendEventOnError } from "../../config/omni";
import { AirportPageComp } from "../../utils/util-constants";
import { fetchGoCashInfo } from "../../common/redux/thunks";
import {useProfileStore} from '@growth/auth-helpers'
import { UPDATE_USER_INFO, userSelector } from "@stencil/user-reducer";
import LeadGenButton from "./containers/LeadGenButton/LeadGenButton";
import { getTravellerInformation } from "../Homepage/redux/thunks";

export default function AirportPage() {
  const showLOBComponents = useSelector(lobDataSelector);
  const way = useSelector(waySelector);
  const seoMeta = useSelector(SeoMetaSelector);
  const userDetails = useSelector(userSelector)
  const showSEOLeadgen = useSelector(showSEOLeadgenSelector);
  const dispatch = useDispatch();

  const {
    userDetailsData, userDetailsFetch
  } = useProfileStore((s) => ({userDetailsData:s.data, userDetailsFetch:s.fetch }));
  
  useEffect(() => {
    try {
      getLoadedComponent(AirportPageComp)
      dispatch(getTravellerInformation())
      dispatch(pageView("goCarsAirportCitySEOScreen"));
      if (!userDetails?.gocashInfo?.t_amt) {
        dispatch(fetchGoCashInfo())
      }
  
      if (!userDetails?.userInfo?.uuid?.length) {
        userDetailsFetch({ platform:"dweb", onError:errorHandling })
      }
    } catch (e) {
      console.log("error", e);
    }
  }, []);

  useEffect(() => {
    if (!userDetails?.userInfo?.uuid && userDetailsData?.uuid) {
      const userInfo = {
        first_name: userDetailsData?.firstName || "",
        last_name: userDetailsData?.lastName || "",
        email: userDetailsData?.email || "",
        profileId: userDetailsData?.profileId || "",
        profile_type: userDetailsData?.profileType || "",
        image_url: userDetailsData?.profileImage || "",
        gender: userDetailsData?.gender || "",
        uuid: userDetailsData?.uuid || ""
      }
      dispatch({
        type: UPDATE_USER_INFO,
        userInfo : userInfo || {}
      });
    }
  }, [userDetailsData, userDetails])

  const errorHandling = (err) => sendEventOnError([{
    field: `user profile info error airport_seo`,
    message: err
  }])

  return (
    <S.SeoWrapper>
      <SeoSearchHeader isSeo />
      <S.PageHeader>
        <SeoPageHeader />
      </S.PageHeader>
      <S.SeoPageWrapper>
        <S.PageRight>
          <AirportTripSelector way={way} slug={seoMeta?.canonical_url} reverseSlug={seoMeta?.reverse_slug} />
          {!showLOBComponents && (
            <React.Fragment>
              <SafetyFeeds isSeo />
              <Listing />
            </React.Fragment>
          )}
          <SeoContainer />
          <SeoInterLinking />
        </S.PageRight>
        <S.PageLeft>
          {!showLOBComponents && <Filter isSeo />}
        </S.PageLeft>
      </S.SeoPageWrapper>
      {showSEOLeadgen ? <LeadGenButton /> : null}
    </S.SeoWrapper>
  );
}
